import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/app.css';
import BackToTop from 'vue-backtotop';
import AOS from 'aos';
import 'aos/dist/aos.css';

const feather = require('feather-icons');
feather.replace();

// Apply theme class to <html> so Tailwind dark: prefix works from any descendant
const appTheme = localStorage.getItem('theme') || 'dark';
if (appTheme === 'dark') {
	document.documentElement.classList.add('dark');
} else {
	document.documentElement.classList.remove('dark');
}

createApp(App)
	.use(router)
	.use(BackToTop)
	.mount('#app');

AOS.init({
	duration: 800,
	easing: 'ease-in-out',
	once: true,
	mirror: false,
});

router.afterEach(() => {
	AOS.refresh();
});
